<div class="statements-invoices">
  <table>
    <tr class="page-table">
      <td colspan="3">
        <kendo-grid class="invoices-invoices-table"
                    #invoicesDataTable
                    [kendoGridBinding]="invoices"
                    [loading]="loading"
                    [pageSize]="pageSize"
                    [resizable]="true"
                    [pageable]="{
                            buttonCount: buttonCount,
                            info: info,
                            type: type,
                            pageSizes: pageSizes,
                            previousNext: previousNext
                    }"
                    [sortable]="true"
                    [sort]="sort"
                    [scrollable]="true"
                    (pageChange)="pageChange($event)"
                    [selectable]="{
                      mode: 'multiple',
                      checkboxOnly: true,
                      metaKeyMultiSelect: false
                    }"
                    filterable="menu"
                    (selectionChange)="selectionChanged($event)"
                    [rowSelected]="isRowSelected"
                    [skip]="skip"
                    [kendoGridSelectBy]="selectionKey"
                    (selectedKeysChange)="keyChange($event)"
                    [reorderable]="false">
          <ng-template kendoGridNoRecordsTemplate>
            <p *ngIf="foundNoInvoices">No records available. Please refine your search and try again.</p>
          </ng-template>
          <ng-template kendoGridToolbarTemplate>
            <kendo-label></kendo-label>
            <input type="checkbox" class="master-select" #terms (selectAllChange)="allRowsSelected($event)" [state]="masterSelectState" kendoCheckBox kendoGridSelectAllCheckbox/>
            <label class="k-label" style="padding-top: 10px;">All Records {{selectionLimitString}}</label>
            <!-- TODO: Add an icon or style to label? -->
            <!-- <label *ngIf="bulk && isAllSelected" style="padding-top: 10px; margin-left: 16px;">Bulk Select Enabled</label> -->
            <kendo-grid-column-chooser style="margin-left: auto;" ></kendo-grid-column-chooser>
          </ng-template>
          <kendo-grid-checkbox-column [width]="75" [showSelectAll]="true" [reorderable]="false" [columnMenu]="false">
            <ng-template kendoGridHeaderTemplate>
              <input class="k-checkbox" id="selectAllCheckboxId" kendoGridSelectAllCheckbox>
              <label class="k-checkbox-label" for="selectAllCheckboxId">Page</label>
            </ng-template>
          </kendo-grid-checkbox-column>
          <kendo-grid-column field="invoiceNumber" title="Invoice Number" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="orderNumber" title="Order Number" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="invoiceType" title="Type" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="customer" title="Customer" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="storeNumber" title="Store" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="invoiceDate" title="Invoice Date" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="invoiceDueDate" title="Due Date" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="downloadType" title="DL" [width]="90"></kendo-grid-column>
          <kendo-grid-column field="invoiceAmount" title="Invoice Total" [width]="150"></kendo-grid-column>
        </kendo-grid>
      </td>
    </tr>
    <tr>
      <td>
        <table class="b-button-bar">
          <tr>
            <td>
              <app-mcl-button text="< Back To Invoice Search" primary="true" (click)="backClicked()">
              </app-mcl-button>
            <td>
              <!-- This button does nothing? -->
              <app-mcl-button text="Mark as Downloaded" primary="true" [disabled]="true">
              </app-mcl-button>
            </td>
            <td>
              <app-mcl-button text="Download" primary="true" (click)="downloadClicked()" [svgIcon]="downloadIcon" [disabled]="(!isValidSelection || outsideDownloadRange) && !loading">
              </app-mcl-button>
            </td>

            <!-- Feature toggle active -->
            <app-mcl-button text="View" primary="true" (click)="viewInvoiceOnbaseStream()" [disabled]="!canView">
            </app-mcl-button>
          </tr>
        </table>
      </td>
    </tr>
  </table>

  <kendo-dialog title='Download in Progress'  *ngIf="opened">
    <p>Currently building download file...</p>
  </kendo-dialog>

  <kendo-dialog title="View Invoices" *ngIf="viewInvoiceModalOpen" (close)="viewInvoiceModalOpen = false">
    <div fxLayout="row" fxLayoutGap="10px">
      <kendo-listview *ngIf="invoiceViewResults.documents" 
                      [height]="300" 
                      [style.width.px]="300" 
                      [data]="displayInvoices"
                      >
        <ng-template kendoListViewHeaderTemplate>
          <h3 style="padding: 10px;">Invoice PDF Documents ({{invoiceViewResults.documents.length}})</h3>
          <div *ngIf="!viewInvoiceReady || loading" style="display: flex; justify-content: center; min-height: 32px;">
            <kendo-loader type="pulsing"
                          themeColor="primary"
                          size="medium">
            </kendo-loader>
            <i>Loading... Please wait... ({{elapsedDisplay}})</i>
          </div>
        </ng-template>

        <ng-template kendoListViewItemTemplate let-dataItem="dataItem" let-index="index">
          <ng-container *ngIf="dataItem.viewUrl; else skeleton">
              <li style="padding: 4px;">
                <a class="success-invoices" [href]="dataItem.viewUrl" target="_blank">View {{dataItem.invoiceNumber}}</a>
              </li>
            </ng-container>
            <ng-template #skeleton>
              <kendo-skeleton shape="text"
                          animation="pulse"
                          width="80%">
              </kendo-skeleton>
            </ng-template>
        </ng-template>
      </kendo-listview>

      <kendo-listview *ngIf="invoiceViewResults.failedInvoices.length > 0" 
                      [height]="300" 
                      [style.width.px]="300" 
                      [data]="invoiceViewResults.failedInvoices">
        <ng-template kendoListViewHeaderTemplate>
          <h3 style="padding: 10px;">Failed Documents</h3>
        </ng-template>
        <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
          <li style="padding: 4px;">
            <a class="failed-invoices">View {{dataItem.invoiceNumber}}</a>
          </li>
        </ng-template>
      </kendo-listview>
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="cancelViewInvoices()">Cancel</button>
      <button kendoButton (click)="viewMasterPDF()" themeColor="primary" [disabled]="!viewInvoiceReady">View All</button>
    </kendo-dialog-actions>
  </kendo-dialog>
    
  <div kendoDialogContainer></div>
</div>
